import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { PUBLIC_PREFIX_PATH } from "configs/AppConfig";

const AccessDenied = () => {
	const styles = {
		container: {
			minHeight: "100vh",
			backgroundColor: "#000",
			color: "#fff",
			overflow: "hidden",
			fontFamily: "Arial, sans-serif",
		},
		header: {
			position: "relative",
			zIndex: 10,
			padding: "1.5rem",
		},
		headerContent: {
			display: "flex",
			justifyContent: "space-between",
			alignItems: "center",
			maxWidth: "1200px",
			margin: "0 auto",
			gap: "1rem",
		},
		logoContainer: {
			display: "flex",
			alignItems: "center",
		},
		logoImage: {
			height: "40px",
			width: "auto",
			objectFit: "contain",
		},
		logoFallback: {
			fontSize: "1.875rem",
			fontWeight: "bold",
		},
		logoTreino: { color: "#f97316" },
		logoDarkside: { color: "#ef4444" },
		logoSeparator: {
			color: "#9ca3af",
			fontSize: "1.5rem",
			flexShrink: 0,
		},
		main: {
			position: "relative",
		},
		bgEffects: {
			position: "absolute",
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			pointerEvents: "none",
		},
		bgGradientLeft: {
			position: "absolute",
			top: 0,
			left: 0,
			width: "50%",
			height: "100%",
			background:
				"linear-gradient(to right, rgba(194, 65, 12, 0.3), transparent)",
		},
		bgGradientRight: {
			position: "absolute",
			top: 0,
			right: 0,
			width: "50%",
			height: "100%",
			background:
				"linear-gradient(to left, rgba(127, 29, 29, 0.3), transparent)",
		},
		content: {
			position: "relative",
			zIndex: 10,
			padding: "4rem 1.5rem",
			textAlign: "center",
			maxWidth: "768px",
			margin: "0 auto",
			minHeight: "70vh",
			display: "flex",
			flexDirection: "column",
			justifyContent: "center",
		},
		badge: {
			display: "inline-flex",
			alignItems: "center",
			backgroundColor: "#ef4444",
			color: "#fff",
			padding: "0.75rem 1.5rem",
			borderRadius: "0.5rem",
			fontSize: "0.875rem",
			fontWeight: "bold",
			textTransform: "uppercase",
			letterSpacing: "0.05em",
			marginBottom: "2rem",
		},
		badgeIcon: {
			fontSize: "1.2rem",
			marginRight: "0.75rem",
		},
		mainTitle: {
			fontSize: "3rem",
			fontWeight: "900",
			color: "#ef4444",
			marginBottom: "1.5rem",
			textTransform: "uppercase",
			letterSpacing: "-0.025em",
			lineHeight: "1.1",
		},
		subtitle: {
			fontSize: "1.25rem",
			color: "#d1d5db",
			marginBottom: "2rem",
			lineHeight: "1.6",
		},
		description: {
			fontSize: "1rem",
			color: "#9ca3af",
			marginBottom: "3rem",
			lineHeight: "1.6",
		},
		footer: {
			textAlign: "center",
			color: "#6b7280",
			fontSize: "0.875rem",
			marginTop: "2rem",
		},
		logosBranding: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			gap: "0.5rem",
			marginTop: "1rem",
		},
	};

	return (
		<div style={styles.container}>
			{/* Header com Logos - Mesmo padrão da página da parceria */}
			<header style={styles.header}>
				<div style={styles.headerContent}>
					{/* Logo Treino.io - Esquerda */}
					<div style={styles.logoContainer}>
						<img
							src={`${PUBLIC_PREFIX_PATH}/logo-comprido.png`}
							alt="Treino.io Logo"
							style={styles.logoImage}
							onError={(e) => {
								e.target.style.display = "none";
								e.target.nextSibling.style.display = "block";
							}}
						/>
						<div
							style={{ ...styles.logoFallback, display: "none" }}
						>
							<span style={styles.logoTreino}>treino</span>
							<span>.io</span>
						</div>
					</div>

					{/* Parceria indicator */}
					<div style={styles.logoSeparator}>×</div>

					{/* Logo DARKSIDE - Direita */}
					<div style={styles.logoContainer}>
						<img
							src={`${PUBLIC_PREFIX_PATH}/logo-darkside.png`}
							alt="DARKSIDE Logo"
							style={styles.logoImage}
							onError={(e) => {
								e.target.style.display = "none";
								e.target.nextSibling.style.display = "block";
							}}
						/>
						<div
							style={{ ...styles.logoFallback, display: "none" }}
						>
							<span style={styles.logoDarkside}>DARKSIDE</span>
						</div>
					</div>
				</div>
			</header>

			{/* Main Content */}
			<main style={styles.main}>
				{/* Background Effects - Mesmo padrão da página da parceria */}
				<div style={styles.bgEffects}>
					<div style={styles.bgGradientLeft}></div>
					<div style={styles.bgGradientRight}></div>
				</div>

				<div style={styles.content}>
					{/* Título Principal */}
					<h1 style={styles.mainTitle}>Acesso Restrito</h1>

					{/* Subtítulo */}
					<p style={styles.subtitle}>
						Esta página é exclusiva para alunos da Universidade
						DARKSIDE
					</p>

					{/* Descrição */}
					<p style={styles.description}>
						Para acessar esta promoção especial, você precisa vir
						através do link oficial enviado pela DARKSIDE. Entre em
						contato com a Universidade DARKSIDE para obter o link
						correto.
					</p>

					{/* Footer */}
					<footer style={styles.footer}>
						<p>
							Powered by{" "}
							<span style={styles.logoTreino}>treino.io</span> +{" "}
							<span style={styles.logoDarkside}>Darkside</span>
						</p>
					</footer>
				</div>
			</main>
		</div>
	);
};

const AccessGuard = ({ children }) => {
	const [hasAccess, setHasAccess] = useState(false);
	const [isChecking, setIsChecking] = useState(true);
	const history = useHistory();
	const location = useLocation();

	useEffect(() => {
		const checkAccess = () => {
			const urlParams = new URLSearchParams(location.search);
			const accessToken = urlParams.get("dsk_auth");

			// Token secreto para acesso
			const validToken = "6uhyjDlCY5n27CN51if58wBJysZYVaSL";

			if (accessToken === validToken) {
				// Acesso válido - remover parâmetro da URL imediatamente
				setHasAccess(true);

				// Remover o parâmetro da URL sem recarregar a página
				const newUrl = new URL(window.location);
				newUrl.searchParams.delete("dsk_auth");

				// Usar replaceState para não adicionar ao histórico
				window.history.replaceState({}, "", newUrl.pathname);

				// Salvar um token temporário no sessionStorage
				sessionStorage.setItem("darkside_access", "granted");
			} else {
				// Verificar se já tem acesso no session
				const sessionAccess = sessionStorage.getItem("darkside_access");
				if (sessionAccess === "granted") {
					setHasAccess(true);
				} else {
					setHasAccess(false);
				}
			}

			setIsChecking(false);
		};

		checkAccess();
	}, [location, history]);

	if (isChecking) {
		const loadingStyles = {
			container: {
				minHeight: "100vh",
				backgroundColor: "#000",
				color: "#fff",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				fontFamily: "Arial, sans-serif",
			},
			content: {
				textAlign: "center",
			},
			spinner: {
				width: "2rem",
				height: "2rem",
				border: "4px solid #374151",
				borderTop: "4px solid #ef4444",
				borderRadius: "50%",
				animation: "spin 1s linear infinite",
				margin: "0 auto 1rem",
			},
			text: {
				color: "#9ca3af",
				fontSize: "1rem",
			},
		};

		return (
			<div style={loadingStyles.container}>
				<div style={loadingStyles.content}>
					<div style={loadingStyles.spinner}></div>
					<p style={loadingStyles.text}>Verificando acesso...</p>
				</div>
				<style>
					{`
						@keyframes spin {
							0% { transform: rotate(0deg); }
							100% { transform: rotate(360deg); }
						}
					`}
				</style>
			</div>
		);
	}

	return hasAccess ? children : <AccessDenied />;
};

export default AccessGuard;
